import {
  Button,
  Col,
  Form,
  Row,
  Input,
  message,
  DatePicker,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { MaterialRequestStatus } from "_helpers";
import {
  binService,
  materialRequestService,
  materialTypeService,
  stockClassificationService,
} from "_services";

function Search(props) {
  const [stockTypes, setStockTypes] = useState([]);
  const [storeBins, setStoreBins] = useState([]);
  const [stockClassifications, setStockClassifications] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    getStockTypes();
    getStockBins();
    getStockClassificationSuggestion();
  }, []);

  const getStockTypes = () => {
    materialTypeService
      .getSuggestion()
      .then((x) => {
        setStockTypes(x.content);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const getStockClassificationSuggestion = () => {
    stockClassificationService
      .getSuggestion()
      .then((x) => {
        setStockClassifications(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const getStockBins = () => {
    binService
      .getSuggestion("")
      .then((y) => {
        setStoreBins(y.content);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";
    if (values.requestNumber) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `requestNumber=${encodeURIComponent(
        values.requestNumber
      )}`;
    }
    if (values.mrnNumber) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `mrnNumber=${encodeURIComponent(values.mrnNumber)}`;
    }
    if (values.customerId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `customerId=${encodeURIComponent(values.customerId)}`;
    }
    if (values.deliveryLocationId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `deliveryLocationId=${encodeURIComponent(
        values.deliveryLocationId
      )}`;
    }
    if (values.orderStage) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `orderStage=${encodeURIComponent(values.orderStage)}`;
    }
    if (values.requestDateRange) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `fromDate=${encodeURIComponent(
        moment(values.requestDateRange[0]).startOf("day").format("YYYY-MM-DD")
      )}&toDate=${moment(values.requestDateRange[1])
        .startOf("day")
        .format("YYYY-MM-DD")}`;
    }
    if (values.stockTypeId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockTypeId=${encodeURIComponent(values.stockTypeId)}`;
    }
    if (values.stockBinId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockBinId=${encodeURIComponent(values.stockBinId)}`;
    }
    if (values.sbuId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `sbuId=${encodeURIComponent(values.sbuId)}`;
    }
    if (values.stockClassificationId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockClassId=${encodeURIComponent(
        values.stockClassificationId
      )}`;
    }
    materialRequestService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          data.pagination.totalRecords,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item name="requestNumber" label="Request Number">
            <Input placeholder="Request Number" allowClear={true} />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="requestDateRange" label="Request Date">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="orderStage" label="Status">
            <Select allowClear>
              {MaterialRequestStatus.map((t) => (
                <Select.Option value={t.value} key={t.value}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}></Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item name="stockTypeId" label="Material Type">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Material Type"
            >
              {stockTypes.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="stockBinId" label="Stock Bin">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Bin"
            >
              {storeBins.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            label="Stock Classification"
            name="stockClassificationId"
          >
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Stock Classification"
            >
              {stockClassifications.length > 0 &&
                stockClassifications.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}></Col>
        <Col span={4}></Col>
      </Row>
    </Form>
  );
}

export default Search;
